import { Reducer } from 'redux'

import {
  BuyerRevenuesAction,
  BuyerRevenuesActionTypes,
  initialBuyerRevenuesState,
  Revenues,
} from './types'

export const reducer: Reducer<Revenues, BuyerRevenuesAction> = (
  state = initialBuyerRevenuesState,
  action
) => {
  switch (action.type) {
    case BuyerRevenuesActionTypes.SET_BUYER_REVENUES: {
      return {
        ...state,
        revenues: action.payload.revenues,
      }
    }
    default:
      return state
  }
}
